import { get } from '@/api/base'

const companyUserApi = {
  get: async companyUuid => {
    const response = await get({ path: `company_user?company_uuid=${companyUuid}` })
    return response.success ? response.data.company_user : null
  },
}

export default companyUserApi
